/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_No_FilesInputs */

const es_feedback_modal_no_files = /** @type {(inputs: Feedback_Modal_No_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin archivos`)
};

const en_feedback_modal_no_files = /** @type {(inputs: Feedback_Modal_No_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No files`)
};

/**
* | output |
* | --- |
* | "No files" |
*
* @param {Feedback_Modal_No_FilesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_no_files = /** @type {((inputs?: Feedback_Modal_No_FilesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_No_FilesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_no_files(inputs)
	return en_feedback_modal_no_files(inputs)
});
export { feedback_modal_no_files as "feedback.modal.no_files" }